var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSelectionFoundBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 115,
    viewBox: "0 0 120 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6641,
    y: 9.01562,
    width: 59.7143,
    height: 59.5082,
    rx: 16,
    fill: "#EAEBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.009 100.084H50.7656C39.7199 100.084 30.7656 91.13 30.7656 80.0843V47.9531C30.7656 36.9074 39.7199 27.9531 50.7656 27.9531H83.1466C94.1923 27.9531 103.147 36.9074 103.147 47.9531V64.0187",
    stroke: "#5D5FEF",
    strokeWidth: 4,
    strokeDasharray: "12 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0956 72.1328L90.4766 75.7394",
    stroke: "#5D5FEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7161 79.3423L72.3828 77.5391",
    stroke: "#5D5FEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.619 86.5547L76 90.1612",
    stroke: "#5D5FEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4297 68.5234L83.2392 74.8349",
    stroke: "#5D5FEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7596 85.5162C88.666 85.2967 88.6405 85.0543 88.6861 84.8201C88.7318 84.586 88.8466 84.3708 89.0159 84.2021C89.1852 84.0335 89.4011 83.9191 89.6361 83.8736C89.8711 83.828 90.1143 83.8535 90.3347 83.9467L116.868 94.7625C117.104 94.859 117.304 95.0277 117.437 95.2443C117.571 95.4608 117.633 95.7141 117.613 95.9677C117.593 96.2213 117.493 96.462 117.327 96.6553C117.161 96.8486 116.938 96.9845 116.69 97.0434L106.199 99.5454C105.766 99.6485 105.37 99.869 105.055 100.182C104.74 100.496 104.518 100.89 104.414 101.322L101.906 111.777C101.847 112.025 101.711 112.248 101.517 112.414C101.323 112.58 101.08 112.681 100.825 112.7C100.57 112.72 100.315 112.659 100.097 112.525C99.8798 112.39 99.7105 112.191 99.6142 111.955L88.7596 85.5162Z",
    stroke: "#5D5FEF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSelectionFoundBlue);
export default __webpack_public_path__ + "static/media/noSelectionFoundBlue.7cfdb50052a1ebeb97655e68edcfc86b.svg";
export { ForwardRef as ReactComponent };